const stickyHeader = {
  header: document.getElementById('jsStickyHeader') as HTMLElement,
  mainContent: document.getElementById('main-content') as HTMLElement,
  logoShowcase: document.getElementById('jsShowcaseLogo') as HTMLElement,
  scrollBtn: document.getElementById('jsScrollBtn') as HTMLElement,
  lastScrollTop: 0,

  init() {
    this.setClass();
    this.setScrollBtn();
  },

  setClass() {
    document.addEventListener('scroll', () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.header.classList.remove('up');
        this.header.classList.add('down');
        this.mainContent.classList.remove('up');
        this.mainContent.classList.add('down');
        this.logoShowcase.classList.remove('up');
        this.logoShowcase.classList.add('down');
      
      } else {
        this.header.classList.add('up');
        this.header.classList.remove('down');
        this.mainContent.classList.add('up');
        this.mainContent.classList.remove('down');
        this.logoShowcase.classList.add('up');
        this.logoShowcase.classList.remove('down');
 
      }
      this.lastScrollTop = st <= 0 ? 0 : st;

      if (window.scrollY === 0) {
        this.header.classList.remove('up');
        this.header.classList.remove('down');
        this.mainContent.classList.remove('up');
        this.mainContent.classList.remove('down');
        this.logoShowcase.classList.remove('up');
        this.logoShowcase.classList.remove('down');
     
      }



    });
  },


  setScrollBtn() {
    window.addEventListener('scroll', () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.scrollBtn.classList.add('activeClass');
      } else {
        this.scrollBtn.classList.add('activeClass');
      }
      this.lastScrollTop = st <= 0 ? 0 : st;

      if(window.scrollY === 0) {
         this.scrollBtn.classList.remove('activeClass');
      }

    }) 

    this.scrollBtn.addEventListener('click', () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    })
  },

};

export default stickyHeader;
